var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 100,
    viewBox: "0 0 130 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#72383D;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30 -277)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 130,
    height: 100,
    transform: "translate(30 277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M127.537,96.2A1.529,1.529,0,0,1,130,97.389v51.924A12.191,12.191,0,0,1,117.813,161.5H12.188A12.191,12.191,0,0,1,0,149.313v-51.9a1.519,1.519,0,0,1,2.463-1.193c5.687,4.418,13.229,10.029,39.127,28.844,5.357,3.91,14.4,12.137,23.41,12.086,9.064.076,18.281-8.328,23.436-12.086C114.334,106.25,121.85,100.613,127.537,96.2ZM65,129c5.891.1,14.371-7.414,18.637-10.512C117.33,94.037,119.895,91.9,127.664,85.811a6.076,6.076,0,0,0,2.336-4.8V76.187A12.191,12.191,0,0,0,117.813,64H12.188A12.191,12.191,0,0,0,0,76.187v4.824a6.113,6.113,0,0,0,2.336,4.8c7.77,6.068,10.334,8.227,44.027,32.678C50.629,121.586,59.109,129.1,65,129Z",
    transform: "translate(30 213.981)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelope);
export default __webpack_public_path__ + "static/media/icon_envelope.8b4e54ac4dca8a541e26b1ae478a9955.svg";
export { ForwardRef as ReactComponent };